import { Check } from 'lucide-react';

export function Checkbox({ label, checked, onChange, disabled = false, className = '', ...inputProps }) {
  return (
    <label className={`checkbox-control ${className}`}>
      <input
        type="checkbox"
        checked={checked}
        onChange={onChange}
        disabled={disabled}
        className="visually-hidden-input"
        {...inputProps}
      />
      <span className="checkbox-control__box">
        <Check />
      </span>
      {label && <span>{label}</span>}
    </label>
  );
}

export function RadioGroup({ options = [], value, onChange, name, className = '' }) {
  return (
    <div className={`radio-group-container ${className}`}>
      {options.map((opt) => {
        const val = typeof opt === 'object' ? opt.value : opt;
        const lbl = typeof opt === 'object' ? opt.label : opt;
        const isChecked = value === val;
        return (
          <label key={val} className="radio-control">
            <input
              type="radio"
              name={name}
              value={val}
              checked={isChecked}
              onChange={() => onChange(val)}
              className="visually-hidden-input"
            />
            <span className="radio-control__circle" />
            <span>{lbl}</span>
          </label>
        );
      })}
    </div>
  );
}

export function Toggle({ label, checked, onChange, disabled = false, className = '' }) {
  return (
    <label className={`toggle-switch ${className}`}>
      <input
        type="checkbox"
        checked={checked}
        onChange={onChange}
        disabled={disabled}
        className="visually-hidden-input"
      />
      <span className="toggle-switch__track">
        <div className="toggle-switch__track-thumb" />
      </span>
      {label && <span>{label}</span>}
    </label>
  );
}
